import { CompositeFilterDescriptor, FilterDescriptor, State } from '@progress/kendo-data-query';
import { TFunction } from 'i18next';
import { ShareShoppingListResultItem } from 'src/types/favorite';
import {
  ShoppingListFilterOption,
  ShoppingListSortOption,
} from 'src/types/view_shopping_lists/ShoppingList';

export const buildShoppingListsFilter = (
  selectedFilter: ShoppingListFilterOption,
  clientId?: string | number,
  searchText = ''
): CompositeFilterDescriptor => {
  const filters: Array<FilterDescriptor | CompositeFilterDescriptor> = [];

  switch (selectedFilter.value) {
    case 'owned-by-me':
      if (clientId != null && clientId !== '') {
        filters.push({
          field: 'sourceClientId',
          operator: 'eq',
          value: String(clientId),
        });
      }
      break;
    case 'shared-with-me':
      filters.push({ field: 'isShare', operator: 'eq', value: true });
      break;
    case 'shared-by-me':
      filters.push({ field: 'isSharedToOthers', operator: 'eq', value: true });
      break;
    case 'copied-to-me':
      filters.push({ field: 'isCopy', operator: 'eq', value: true });
      break;
    default:
      break;
  }

  const term = searchText.trim();
  if (term) {
    filters.push({
      logic: 'or',
      filters: [
        { field: 'title', operator: 'contains', value: term, ignoreCase: true },
        { field: 'owner', operator: 'contains', value: term, ignoreCase: true },
      ],
    });
  }

  return { logic: 'and', filters };
};

export const buildShoppingListsDataState = (
  selectedFilter: ShoppingListFilterOption,
  selectedSort: ShoppingListSortOption,
  clientId?: string | number,
  searchText = ''
): State => ({
  filter: buildShoppingListsFilter(selectedFilter, clientId, searchText),
  sort: [
    {
      field: 'title',
      dir: selectedSort.value === 'name-desc' ? 'desc' : 'asc',
    },
  ],
});

/** Builds legacy-style share toast lines from ShareShoppingList API results (per folder). */
export const buildShareShoppingListToastMessages = (
  results: ShareShoppingListResultItem[],
  t: TFunction,
  folderNamesById: Record<number, string> = {}
): string[] => {
  const messages: string[] = [];

  results.forEach((result) => {
    const folderName = folderNamesById[result.folderId]?.trim() || String(result.folderId);

    if (result.countOfAdded > 0) {
      messages.push(
        t('shoppingList.shareAddedClients', {
          count: result.countOfAdded,
          folderName,
        })
      );
    }
    if (result.countOfRemoved > 0) {
      messages.push(
        t('shoppingList.shareRemovedClients', {
          count: result.countOfRemoved,
          folderName,
        })
      );
    }
  });

  return messages;
};
